function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';
import _button from "./../../button2/button2.react.js";

var Button = _button.applyDecls();

import "./../../button2/button2.css";
import "./../../../desktop.blocks/button2/button2.css";
import "./../../button2/_theme/button2_theme_websearch.css";
import "./../../../desktop.blocks/button2/_theme/button2_theme_websearch.css";


export default decl({
    block: 'search2',
    elem: 'button',
    content: function content(_ref) {
        var children = _ref.children,
            props = _objectWithoutProperties(_ref, ['children']);

        return props.button || React.createElement(
            Button,
            props,
            children
        );
    }
}, {
    isButton: function isButton(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'search2__button';
    }
});